import axios from 'axios';

export const baseUrl = 'https://service.saphengel.com.br:8485/';

export const axiosApi = ({ noAuth } = { noAuth: false }) => {

    const token = localStorage.getItem('token');

    const api = axios.create({
        baseURL: baseUrl,
        headers: !noAuth ? {
            'Authorization': `bearer ${token}`
        } : undefined
    });

    return api;

}

export default axiosApi;